<script>
import Wysiwyg from '@/components/wysiwyg/Wysiwyg'
import SectionHeader from '@/sections/section-header/SectionHeader'
import SectionCheckin from '@/sections/section-checkin/SectionCheckin'
import SectionDiscover from '@/sections/section-discover/SectionDiscover'
import SectionNews from '@/sections/section-news/SectionNews'
import SectionCollectionListing from '@/sections/section-collection-listing/SectionCollectionListing'
import Picture from '@/components/image-caption/ImageCaption'
import Buttons from '@/components/buttons/Buttons'
import SectionNeedtoknow from '@/sections/section-needtoknow/SectionNeedtoknow'
import SectionTablelinks from '@/sections/section-tablelinks/SectionTablelinks.vue'
import SectionUpsell from '@/sections/section-upsell/SectionUpsell.vue'
import SectionFaq from '@/sections/section-faq/SectionFaq.vue'
import SectionLargepagelinks from '@/sections/section-largepagelinks/SectionLargepagelinks.vue'
import BuyFromMewsButton from '@/components/buy-from-mews/BuyFromMewsButton'
import Wayfinder from '@/components/location-sharing/Wayfinder'
import IconList from '@/components/icon-list/IconList'
import ImageAndText from '@/components/image-and-text/ImageAndText'
import SectionRichText from '@/sections/section-richtext/SectionRichText'
import SectionQuote from '@/sections/section-quote/SectionQuote'
import SectionVideo from '@/sections/section-video/SectionVideo'
import ActionButton from '@/sections/action-button/ActionButton'
import SectionScribble from '@/sections/section-scribble/SectionScribble'
import Settings from '@/sections/settings/Settings'



export default {
  name: 'ContentRenderer',
  components: {
    Wysiwyg,
    SectionHeader,
    SectionCheckin,
    SectionDiscover,
    SectionNews,
    Picture,
    Buttons,
    SectionNeedtoknow,
    SectionTablelinks,
    SectionUpsell,
    SectionFaq,
    SectionLargepagelinks,
    SectionCollectionListing,
    Wayfinder,
    SectionRichText,
    SectionQuote,
    SectionVideo,
    SectionScribble,
    'SectionBuyFromMews': BuyFromMewsButton,
    'sectionAccount': Settings,
    'action_button' : ActionButton,
    'sectionIconList': IconList,
    'sectionImageandtext': ImageAndText
  },
  props: {
    content: {
      type: [Object, Boolean],
      default: false
    }
  },
  computed: {
    debug () {
      return process.env.NODE_ENV === 'development'
    }
  },
  methods: {
    dataCheck () {
      if (!this.content) {
        return 'No content available'
      }
      if (!this.content.type) {
        return 'No type is set on the contentObject'
      }
      if (!this.isHTML()) {
        if (this.debug && !this.isComponentDefined(this.content.type)) {
          return `Component ${this.mapComponentType(this.content.type)} (source field: '${this.content.type}') is can not be rendered because the component is not defined`
        }
      }

      return false
    },
    isHTML () {
      return this.content.type === 'text'
    },
    isComponentDefined (componentName) {
      componentName = this.mapComponentType(componentName)
      for (const prop in this.$options.components) {
        if (prop.toLowerCase() === componentName.replaceAll('-', '').toLowerCase()) {
          return true
        }
      }
      return false
    },
    mapComponentType (componentType) {
      const rename = {
        image: 'Picture'
      }
      for (const oldType in rename) {
        if (componentType === oldType) {
          return rename[oldType]
        }
      }

      return componentType
    },
    formatProps (props) {
      let newProps = {}
      for (const prop in props) {
        // newProps[prop.replaceAll('_', '-')] = props[prop]
        newProps[prop] = props[prop]
      }
      return newProps
    }
  },
  render (h) {
    let error = undefined
    if (error = this.dataCheck()) {
      return (<pre>{error}</pre>)
    }
    if (this.isHTML()) {
      return h('wysiwyg', {props: {'content': this.content.text}})

    }
    return h(this.mapComponentType(this.content.type), {props: {...this.formatProps(this.content)}})
  }
}
</script>
